// msalConfig.js
export const msalConfig = {
  auth: {
    clientId: "f50ba890-143b-4557-a466-e7c778f0e74c",
    authority: "https://login.microsoftonline.com/64cdb909-6488-4328-8a6e-dad0b7db83fd", // or 'common' for multi-tenant
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: true,
  },
};
export const loginRequest = {
  scopes: ["User.Read", "User.ReadBasic.All", "User.Read.All"], // Add necessary Microsoft Graph scopes here
};
